import { render, staticRenderFns } from "./SocleNotificationApprovalWorkflowList.vue?vue&type=template&id=1141862e&"
import script from "./SocleNotificationApprovalWorkflowList.vue?vue&type=script&lang=ts&"
export * from "./SocleNotificationApprovalWorkflowList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports